<section id="section-report" class="container-fluid mt-1">
  <div class="row" *ngIf="quotationPrintContract">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{quotationPrintContract.quotationId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{quotationPrintContract.quotationId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{quotationPrintContract.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{quotationPrintContract.branchName}}</p>

                  <!--Nombre Cotización -->
                  <p id="nombre-cotizacion-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    Cotización {{quotationPrintContract.quotationType}}
                    Nro.{{quotationPrintContract.consecutive}}</p>

                  <!--Nombre Versión -->
                  <p id="nombre-version-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    Versión {{quotationPrintContract.consecutiveVersion}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion'
                    | formatLabelPipe : elementsLabel}}</label>

                  <p id="direccion-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{quotationPrintContract.branchAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{quotationPrintContract.branchPhone}}</p>

                  <!-- Fecha Cotizacion -->
                  <label id="t-fecha-cotizacion-{{quotationPrintContract.quotationId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-cotizacion' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-cotizacion-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{quotationPrintContract.dateQuotation | date: 'dd/MM/yyyy'}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{quotationPrintContract.quotationId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>

                  <p id="cliente-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{quotationPrintContract.nameClient}}
                  </p>

                  <!--Obra  -->
                  <label id="t-obra-{{quotationPrintContract.quotationId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-obra' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="obra-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{quotationPrintContract.nameConstructionSite}}
                  </p>

                  <!--Contacto  -->
                  <label id="t-contacto-{{quotationPrintContract.quotationId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-contacto' | formatLabelPipe : elementsLabel}}</label>
                  <p id="contacto-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{quotationPrintContract.contact}}
                  </p>

                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{quotationPrintContract.quotationId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-obra' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="telefono-obra-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{quotationPrintContract.phones}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-obra-{{quotationPrintContract.quotationId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion-obra' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="direccion-obra-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{quotationPrintContract.addressConstructionSite}}</p>

                  <!-- Valor Montaje  -->
                  <label id="t-valor-montaje-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-valor-montaje' | formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-montaje-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">

                    <ng-container *ngIf="getLabelPrintFormat('valor-montaje'); else currencyFormat">
                      {{ quotationPrintContract.mountingValue |
                      dynamicFormatPipe:'decimal':getLabelPrintFormat('valor-montaje') }}
                    </ng-container>
                    <ng-template #currencyFormat>
                      {{ quotationPrintContract.mountingValue | currency }}
                    </ng-template>
                  </p>

                  <!-- Asunto  -->
                  <label id="t-asunto-{{quotationPrintContract.quotationId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-asunto' | formatLabelPipe : elementsLabel}}</label>
                  <p id="asunto-{{quotationPrintContract.quotationId}}" class="lh-1" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{
                    quotationPrintContract.observation}}
                  </p>

                  <!-- Correo  -->
                  <label id="t-correo-{{quotationPrintContract.quotationId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-correo' | formatLabelPipe : elementsLabel}}</label>
                  <p id="correo-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{quotationPrintContract.email}}
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <div *ngFor="let  detailModel of quotationPrintContract.quotationDetails">
                  <app-custom-table-print id="detalle-cotizacion-{{quotationPrintContract.quotationId}}"
                    [columns]="columns" [data]="[detailModel]" [idMap]="idMap"
                    [documentId]="detailModel.quotationDetailId" [footerVisible]="false" [editFormat]="editFormat"
                    (clickTableEvent)="clickTable($event)"
                    (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
                  <!------------------------------------------------------- DESPIECE ---------------------------------------------->
                  <div class="px-2 pt-2" *ngIf="detailModel.breakdownPrints!.length > 0">

                    <app-custom-table-print id="despiece-cotizacion-{{detailModel.quotationDetailId}}"
                      [columns]="columnsBreakdown" [data]="detailModel.breakdownPrints" [idMap]="idMapBreakdown"
                      [documentId]="detailModel.quotationDetailId" [footerVisible]="false" [editFormat]="editFormat"
                      (clickTableEvent)="clickTable($event)"
                      (newIndexColumns)="onColumnReorderBreakdown($event)"></app-custom-table-print>
                  </div>
                  <!------------------------------------------------------- IMAGANES ---------------------------------------------->
                  <div id="content-images-{{detailModel.quotationDetailId}}" (mousedown)="onMouseDown($event)"
                    *ngIf="detailModel.previews; else emptyDiv" class="d-flex gap-5 m-1 py-1 px-2 content-images">
                    <div *ngFor="let preview of detailModel.previews; let i = index">
                      <p-image [src]="preview" alt="Imagen {{ i + 1 }}" width="150" height="150" [preview]="false" />
                    </div>
                  </div>
                  <ng-template #emptyDiv>
                    <div class="mt-3">
                    </div>
                  </ng-template>
                </div>
                <div id="container-totals">
                  <div id="totals">

                    <!-- peso total -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-peso-{{quotationPrintContract.quotationId}}"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{ 'foot-t-total-peso' | formatLabelPipe : elementsLabel}}
                      </label>
                      <p id="foot-total-peso-espacio-{{quotationPrintContract.quotationId}}"></p>
                      <p id="foot-total-peso-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        <ng-container *ngIf="getLabelPrintFormat('foot-total-peso'); else currencyFormatPeso">
                          {{ quotationPrintContract.totalWeight |
                          dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-total-peso') }}
                        </ng-container>
                        <ng-template #currencyFormatPeso>
                          {{ quotationPrintContract.totalWeight }} Kg
                        </ng-template>
                      </p>
                    </div>

                    <!-- reposición total -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-rep-{{quotationPrintContract.quotationId}}"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{ 'foot-t-total-rep' | formatLabelPipe : elementsLabel}}
                      </label>
                      <p id="foot-total-rep-espacio-{{quotationPrintContract.quotationId}}"></p>
                      <p id="foot-total-rep-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        <ng-container *ngIf="getLabelPrintFormat('foot-total-rep'); else currencyFormatReposicion">
                          {{ quotationPrintContract.totalReplacementValue |
                          dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-total-rep') }}
                        </ng-container>
                        <ng-template #currencyFormatReposicion>
                          {{ quotationPrintContract.totalReplacementValue | currency }}
                        </ng-template>
                      </p>
                    </div>

                    <!-- subtotal -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-subtotal-{{quotationPrintContract.quotationId}}"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{ 'foot-t-total-subtotal' | formatLabelPipe : elementsLabel}}
                      </label>
                      <p id="foot-total-subtotal-espacio-{{quotationPrintContract.quotationId}}"></p>
                      <p id="foot-total-subtotal-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        <ng-container *ngIf="getLabelPrintFormat('foot-total-subtotal'); else currencyFormatSubtotal">
                          {{ quotationPrintContract.totalSubtotalValue |
                          dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-total-subtotal') }}
                        </ng-container>
                        <ng-template #currencyFormatSubtotal>
                          {{ quotationPrintContract.totalSubtotalValue | currency }}
                        </ng-template>
                      </p>
                    </div>

                    <!-- total -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                        (dragstart)="onDragStart()">
                        {{'foot-t-total' | formatLabelPipe : elementsLabel}}
                      </label>
                      <p id="foot-total-espacio-{{quotationPrintContract.quotationId}}"></p>
                      <p id="foot-total-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        <ng-container *ngIf="getLabelPrintFormat('foot-total'); else currencyFormatTotal">
                          {{ quotationPrintContract.totalValue |
                          dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-total') }}
                        </ng-container>
                        <ng-template #currencyFormatTotal>
                          {{ quotationPrintContract.totalValue | currency }}
                        </ng-template>
                      </p>
                    </div>

                    <!-- Valor Iva -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-valor-iva-{{quotationPrintContract.quotationId}}"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{ 'foot-t-total-valor-iva' | formatLabelPipe : elementsLabel}}
                      </label>
                      <p id="foot-total-valor-iva-espacio-{{quotationPrintContract.quotationId}}"></p>
                      <p id="foot-total-valor-iva-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        <ng-container *ngIf="getLabelPrintFormat('foot-total-valor-iva'); else currencyFormatIva">
                          {{ quotationPrintContract.totalIvaValue |
                          dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-total-valor-iva') }}
                        </ng-container>
                        <ng-template #currencyFormatIva>
                          {{ quotationPrintContract.totalIvaValue | currency }}
                        </ng-template>
                      </p>
                    </div>

                    <!-- total + iva -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-totaliva-{{quotationPrintContract.quotationId}}"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{ 'foot-t-total-totaliva' | formatLabelPipe : elementsLabel}}
                      </label>
                      <p id="foot-total-totaliva-espacio-{{quotationPrintContract.quotationId}}"></p>
                      <p id="foot-total-totaliva-{{quotationPrintContract.quotationId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        <ng-container *ngIf="getLabelPrintFormat('foot-total-totaliva'); else currencyFormatTotalIva">
                          {{ quotationPrintContract.totalWithIvaValue |
                          dynamicFormatPipe:'decimal':getLabelPrintFormat('foot-total-totaliva') }}
                        </ng-container>
                        <ng-template #currencyFormatTotalIva>
                          {{ quotationPrintContract.totalWithIvaValue | currency }}
                        </ng-template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <!-- Observación cotización en sucursal-->
                <p id="observacion-cotizacion-suc-{{quotationPrintContract.quotationId}}" class="lh-1 text-format"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{quotationPrintContract.branchQuotationObservation}}</p>

                <!-- Condiciones comercial alquiler/venta-->
                <label *ngIf="quotationPrintContract.swConditions"
                  id="t-observacion-cotizacion-suc-{{quotationPrintContract.quotationId}}" class="mt-3 mb-1"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-observacion-cotizacion-suc' |
                  formatLabelPipe : elementsLabel}}</label>
                <p *ngIf="quotationPrintContract.swConditions"
                  id="condiciones-comerciales-{{quotationPrintContract.quotationId}}" class="lh-1 text-format"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{quotationPrintContract.enterpriseParticularCondition }}
                </p>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{quotationPrintContract.quotationId}}" class="foot mt-1 container-observations">

                <p id="observacion-1-{{quotationPrintContract.quotationId}}" class="lh-1"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> Los valores antes descritos no incluyen
                  IVA.</p>

                <p *ngIf="quotationPrintContract.swConditions" id="observacion-2-{{quotationPrintContract.quotationId}}"
                  class="lh-1" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> Las condiciones
                  comerciales que
                  aparecen en el documento adjunto forman
                  parte integral de esta cotización.</p>

                <!-- Observaciones -->
                <label id="t-observaciones-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-observaciones' | formatLabelPipe : elementsLabel}}</label>

                <p id="observacion-{{quotationPrintContract.quotationId}}" class="lh-1 text-format"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{quotationPrintContract.observation }}
                </p>

                <!-- Firma Recibido-->
                <label id="t-firma-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-firma' | formatLabelPipe : elementsLabel}}</label>


                <p id="linea-firma-{{quotationPrintContract.quotationId}}" class="write-line" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <!--Vendedor  -->
                <label id="t-vendedor-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-vendedor'
                  | formatLabelPipe : elementsLabel}}</label>

                <p id="vendedor-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{quotationPrintContract.sellerName}}</p>

                <p id="vendedor-cargo-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{quotationPrintContract.sellerPosition}}</p>

                <p id="vendedor-direccion-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{quotationPrintContract.sellerAddress}}</p>

                <p id="vendedor-telefonos-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{quotationPrintContract.sellerPhones}}</p>

                <p id="vendedor-correo-{{quotationPrintContract.quotationId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{quotationPrintContract.sellerEmail}}</p>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1">
              <div class="row">
                <div class="col-12 d-flex gap-2">
                  <!-- Versión CW-->
                  <p class="label-footer-page">{{version}}</p>

                  <!-- Fecha Impresión-->
                  <label class="label-footer-page">Fecha</label>
                  <p class="footer-page">{{dateNow | date: 'dd/MM/yyyy'}}</p>

                  <!-- Hora Impresión-->
                  <label class="label-footer-page">Hora:</label>
                  <p class="footer-page">{{dateNow | date: 'hh:mm:ss a'}}</p>

                  <!-- Usuario Impresión-->
                  <label class="label-footer-page">Usuario:</label>
                  <p class="footer-page">{{userAuthenticated}}</p>
                </div>
              </div>
              <p id="message"></p>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>